import { type ReleaseFlag, useReleaseManagement } from '@/utility/feature-management';
import { RBAC_FLAG_CONFIG, type RbacFlags, type RbacFlagKey } from '@/components/users/rolesAndPermissions/types';

export const useRbacFlags = (): RbacFlags => {
  const systemAccess = useReleaseManagement(RBAC_FLAG_CONFIG.systemAccess);
  const checkInOut = useReleaseManagement(RBAC_FLAG_CONFIG.checkInOut);
  const bookingUncancel = useReleaseManagement(RBAC_FLAG_CONFIG.bookingUncancel);
  const printBookingDetails = useReleaseManagement(RBAC_FLAG_CONFIG.printBookingDetails);
  const productPackages = useReleaseManagement(RBAC_FLAG_CONFIG.productPackages);
  const insights = useReleaseManagement(RBAC_FLAG_CONFIG.insights);
  const insightsCategories = useReleaseManagement(RBAC_FLAG_CONFIG.insightsCategories);
  const driverShiftTrackerPermissions = useReleaseManagement(RBAC_FLAG_CONFIG.driverShiftTrackerPermissions);
  const locationsManagement = useReleaseManagement(RBAC_FLAG_CONFIG.locationsManagement);
  const lanePlanning = useReleaseManagement(RBAC_FLAG_CONFIG.lanePlanning);
  const updateBookingDates = useReleaseManagement(RBAC_FLAG_CONFIG.updateBookingDates);

  return {
    systemAccess,
    checkInOut,
    bookingUncancel,
    printBookingDetails,
    productPackages,
    insights,
    insightsCategories,
    driverShiftTrackerPermissions,
    locationsManagement,
    lanePlanning,
    updateBookingDates,
  } satisfies RbacFlags;
};

export const RELEASE_FLAG_TO_KEY_MAP = Object.entries(RBAC_FLAG_CONFIG).reduce(
  (acc, [key, flag]) => {
    acc[flag] = key as RbacFlagKey;
    return acc;
  },
  {} as Record<string, RbacFlagKey>
);


export const getFlagState = (
  flags: RbacFlags,
  releaseFlag: ReleaseFlag | undefined
): boolean => {
  //no featue flag found for permission, allow permission
  if (!releaseFlag) {
    return true;
  }

  const flagKey = RELEASE_FLAG_TO_KEY_MAP[releaseFlag];
  return flags[flagKey];
};
